<div class="carousel-main-wrapper">
    <div class="carousel-container">
      <input type="radio" *ngFor="let carouselItem of carouselItems; let i = index" [id]="carouselItem.id" name="carousel-slider" [checked]="i === 0">
      <div class="carousel-cards">
        <label class="carousel-card" *ngFor="let carouselItem of carouselItems; let i = index" [for]="carouselItem.id" [id]="'carousel-song-' + (i+1)">
          <img [src]="carouselItem.src" alt="song">
        </label>
      </div>
      <div class="carousel-player">
        <div class="carousel-upper-part">
          <div class="carousel-play-icon">
            <svg width="20" height="20" fill="#2992dc" stroke="#2992dc" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="feather feather-play" viewBox="0 0 24 24">
              <defs />
              <path d="M5 3l14 9-14 9V3z" />
            </svg>
          </div>
          <div class="carousel-info-area" id="carousel-test">
            <label class="carousel-song-info" *ngFor="let carouselItem of carouselItems; let i = index" [id]="'carousel-song-info-' + (i+1)">
              <div class="carousel-title"></div>
              <div class="carousel-sub-line">
                <div class="carousel-subtitle">{{ carouselItem.description }}</div>
              </div>
            </label>
          </div>
        </div>
        <div class="carousel-progress-bar">
          <span class="carousel-progress"></span>
        </div>
      </div>
    </div>
  </div>